import { Link } from 'react-router-dom';
import './HomePage.css';

export function HomePage() {
    return (
        <div className="home-page">
            <section className="hero">
                <div className="container">
                    <h1 className="hero-title">
                        现代化的
                        <span className="gradient-text">代码托管平台</span>
                    </h1>
                    <p className="hero-subtitle">
                        基于 Cloudflare 边缘网络，为您提供快速、安全、可靠的代码托管服务
                    </p>
                    <div className="hero-actions">
                        <Link to="/login" className="btn btn-primary btn-lg">
                            立即登录
                        </Link>
                        <Link to="/explore" className="btn btn-secondary btn-lg">
                            探索项目
                        </Link>
                    </div>
                </div>
            </section>

            <section className="features">
                <div className="container">
                    <h2 className="section-title">核心功能</h2>
                    <div className="grid grid-3">
                        <div className="feature-card">
                            <div className="feature-icon">🚀</div>
                            <h3>全球加速</h3>
                            <p>利用 Cloudflare 全球边缘网络，无论您在哪里，都能获得极速体验</p>
                        </div>
                        <div className="feature-card">
                            <div className="feature-icon">🏢</div>
                            <h3>群组管理</h3>
                            <p>支持群组层级结构，灵活组织您的团队和项目</p>
                        </div>
                        <div className="feature-card">
                            <div className="feature-icon">🔐</div>
                            <h3>安全可靠</h3>
                            <p>多重认证方式，细粒度权限控制，保护您的代码安全</p>
                        </div>
                        <div className="feature-card">
                            <div className="feature-icon">📦</div>
                            <h3>完整 Git 支持</h3>
                            <p>完整的 Git Smart HTTP 协议实现，无缝对接现有工作流</p>
                        </div>
                        <div className="feature-card">
                            <div className="feature-icon">🌿</div>
                            <h3>分支管理</h3>
                            <p>直观的分支可视化，轻松进行代码审查和合并</p>
                        </div>
                        <div className="feature-card">
                            <div className="feature-icon">⚡</div>
                            <h3>Serverless 架构</h3>
                            <p>无需运维服务器，按需自动扩展，始终保持高可用</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="cta">
                <div className="container">
                    <h2>准备好开始了吗？</h2>
                    <p>立即登录，开始托管您的代码</p>
                    <Link to="/login" className="btn btn-primary btn-lg">
                        立即登录
                    </Link>
                </div>
            </section>
        </div>
    );
}
